const widthSize1281 = 1281;
const widthSize1280 = 1280;
const widthSize768 = 768;

export { widthSize1281, widthSize1280, widthSize768 };
